import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const Footer = () => {
  const [showTerms, setShowTerms] = useState(false);

  return (
    <>
      <Modal
        show={showTerms}
        onHide={() => setShowTerms(!showTerms)}
        backdrop="static"
        size="xl"
        scrollable
      >
        <Modal.Header>
          <Modal.Title>
            <strong>
              <span>PILLAR 9&trade; - Terms of Service</span>
            </strong>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Data Disclaimer</h4>
          <p>Information is deemed reliable but is NOT guaranteed accurate.</p>
          <p>The Listing Agent(s) who creates the Listing is responsible for the Listing information to be accurate and shall use their best efforts to transfer copyright title for photographs and other copyrightable material to the Pillar 9&trade;.</p>
          <p>No warranties or representations are made by PILLAR 9&trade;or our partners.</p>
          <h4 className="mt-4">Authorized Use</h4>
          <ol>
            <li className="mb-2">
              The information contained on the PILLAR 9&trade; MLS&reg; System is confidential and shall not be distributed to unauthorized persons (including other real estate boards) or used in any unauthorized manner.
              The Shareholders agree that information and data contained on the PILLAR 9&trade; MLS&reg; System may only be used in an Authorized manner.
            </li>
            <li>
              <p className="mb-2">For the purposes of this Agreement:</p>
              <ol style={{ listStyleType: 'lower-alpha' }}>
                <li>
                  <p className="mb-2">&ldquo;Authorized Use&rdquo; or &ldquo;Authorized manner&rdquo; &ldquo;of the MLS&reg; System means:</p>
                  <ol style={{ listStyleType: 'lower-roman' }}>
                    <li className="mb-2">The extraction of data from the MLS&reg; System by Members in good standing necessary to assist them in representing their Clients/Customers or specific identified customers in the Trade of real property;</li>
                    <li className="mb-2">The ability of Members in good standing to remove reference to the Listing Brokerage and Listing Associate when representing specific clients, or specific identified customers in the Trade of real estate; and</li>
                    <li className="mb-2">Any specific use authorized in writing by the Corporation.</li>
                  </ol>
                </li>
                <li>
                  <p className="mb-2">&ldquo;Unauthorized Use&rdquo; of the MLS&reg; System is any use not set out in the above section and includes, but is not limited to:</p>
                  <ol style={{ listStyleType: 'lower-roman' }}>
                    <li className="mb-2">The sale or distribution of any portion of the MLS&reg; System to any third parties;</li>
                    <li className="mb-2">
                      Use of the MLS&reg; System for direct or personal contact or communication with another Member&rsquo;s Client/Customer when the status of a listing on PILLAR 9&trade; MLS&reg; System is marked as either Expired (X),
                      or Terminated (T) or and the Member knows or ought to know that a written service agreement has been or is in place.&nbsp;
                    </li>
                    <li className="mb-2">
                      Any general or institutional advertising of a Member&rsquo;s services through radio, television, open houses, or other means of reaching a large group of the public not directed specifically to persons having had
                      a written service agreement that is now either expired (X) or terminated (T) or any contact or communication that was specifically requested or initiated by the Client/Customer, is not deemed to be an unauthorized
                      use of the MLS&reg; System.&nbsp;
                    </li>
                    <li className="mb-2">No use is unauthorized if consented to in writing by the Corporation. Anyone requesting such consent is required to meet all requirements as determined by the Corporation.&nbsp;</li>
                    <li className="mb-2">
                      The Corporation shall be responsible for ensuring the enforcement of agreements that set out the authorized use of data from the MLS&reg;
                      System by third parties or to take necessary means to prevent unauthorized use.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>
          <h4>Ownership and Copyright</h4>
          <ol>
            <li className="mb-2">
              PILLAR 9&trade; is the owner of the copyright in its MLS&reg; SYSTEM database. The MLS&reg; SYSTEM database is a licensed product for the exclusive use of Members and other authorized users and any use of this
              data for any unauthorized purpose is prohibited. The right to use, reproduce or download the data is subject to the authority of PILLAR 9&trade; and is limited to the specific uses permitted by PILLAR 9&trade;.
            </li>
            <li className="mb-2">
              Members shall comply with, observe, and be bound by all restrictions, copyright notices, or other limitations of access to the PILLAR 9&trade; &nbsp;MLS&reg; SYSTEM database and use thereof as may be adopted
              by the Directors from time to time.
            </li>
            <li className="mb-2">A member, in submitting Listing information to PILLAR 9&trade;, consents to such use of that information as PILLAR 9&trade; determines.&nbsp;</li>
            <li className="mb-2">
              <p className="mb-2">The Member shall advise and obtain the Principal&rsquo;s consent that:&nbsp;</p>
              <ol style={{ listStyleType: 'lower-alpha' }}>
                <li className="mb-2">
                  All information concerning the Agency Agreement, the properties affected thereby, and the transactions thereunder shall be made available not only to all other Members but also to any
                  third-party authorized users with whom PILLAR 9&trade; has a contract and their Principals;
                </li>
                <li className="mb-2">PILLAR 9&trade; may, at its option, advertise in any medium, including the Internet, any properties listed on the MLS&reg; SYSTEM database;&nbsp;</li>
                <li className="mb-2">PILLAR 9&trade; may retain and distribute the listing information indefinitely and may compile and publish any statistical analysis, including historical MLS&reg; SYSTEM data, on such information.&nbsp;</li>
              </ol>
            </li>
            <li className="mb-2">
              PILLAR 9&trade; shall not be responsible for any indirect, special, or consequential damages or any other obligation or liability arising out of, or in any way connected with, the MLS&reg; SYSTEM database including,
              but not limited to, computer failure or interruption, or negligence.&nbsp;
            </li>
            <li className="mb-2">The Directors may from time to time establish fees for use of the PILLAR 9&trade; &nbsp;MLS&reg; SYSTEM information.</li>
          </ol>
          <h4 className="mt-4">Cookies</h4>
          <p>When you use OnePlatform, PILLAR 9&trade;&nbsp;uses Cookies to track your interactions, usage, and patterns in order to better understand and meet your preferences, to provide you with a customized experience.</p>
          <p>PILLAR 9&trade;&nbsp;uses third-party technology for tracking and in doing so, a third-party Cookie may be placed or recognized by your browser.</p>
          <h4 className="mt-4">Accessibility</h4>
          <p>PILLAR 9&trade; strives to ensure that its applications and content are accessible to persons with disabilities including users of screen reader technology.</p>
          <p>WCAG 2.0 Level AA is used as a guide for developing online experiences that serve all of our users.</p>
          <p>Please be aware that our efforts to maintain accessibility and usability are ongoing.</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="col text-center mt-6">
            <Button onClick={() => setShowTerms(!showTerms)} size="lg"> OK </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <footer className="page-footer height-5" role="contentinfo">
        <div className="d-flex align-items-center flex-1 text-muted">
          <span className="hidden-md-down">
            {new Date().getFullYear()}
            &nbsp;&copy; OnePlatform by&nbsp;
            <a
              href="https://www.pillarnine.com"
              className="text-primary fw-500 mr-2"
              title="Pillar 9™"
              target="_blank"
              rel="noreferrer"
            >
              Pillar 9™
            </a>
          </span>
        </div>
        <div className="text-muted">
          By using OnePlatform you agree to the
          <a href="#Terms" onClick={() => setShowTerms(!showTerms)} className="text-primary fw-500 ml-1">Terms of Service</a>
        </div>
      </footer>
    </>
  );
};

export default Footer;
